/**
 * Counter Animation Script
 * Animates number counters when they come into view
 */
document.addEventListener('DOMContentLoaded', function() {
  // Check if IntersectionObserver is supported
  if ('IntersectionObserver' in window) {
    const counterSection = document.querySelector('.counter-stats-section');
    if (!counterSection) return;
    
    const counters = counterSection.querySelectorAll('.counter');
    let animated = false;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Start animation when counter section is in view
        if (entry.isIntersecting && !animated) {
          animated = true;
          
          counters.forEach(counter => {
            const target = parseInt(counter.getAttribute('data-count'), 10);
            const duration = 2000; // Animation duration in milliseconds
            
            // Different speeds based on number size
            let speed = Math.ceil(duration / target);
            
            // For larger numbers, use a different approach to avoid too many updates
            if (target > 1000) {
              speed = Math.ceil(duration / 100);
            }
            
            let current = 0;
            const increment = target > 1000 ? Math.ceil(target / 100) : 1;
            
            const updateCounter = () => {
              current += increment;
              
              if (current > target) {
                current = target;
              }
              
              // Format number with commas for thousands
              const formattedNumber = current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              counter.textContent = formattedNumber;
              
              if (current < target) {
                setTimeout(updateCounter, speed);
              }
            };
            
            updateCounter();
          });
        }
      });
    }, { threshold: 0.1 });
    
    observer.observe(counterSection);
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    const counters = document.querySelectorAll('.counter');
    counters.forEach(counter => {
      const target = counter.getAttribute('data-count');
      counter.textContent = target;
    });
  }
});
